import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker'
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import { translateMask } from 'features/expedientes/libs/DateFieldsHelpers'
import { useEffect, useState } from 'react'

const CustomDateTimeComponent = ({ campo, dates, valor, onChange = (v) => {} }) => {
  const { openTo, views } = translateMask(campo.mascara_formato)

  const [value, setValue] = useState(valor)

  const handleChange = (newValue) => {
    setValue(newValue)
    onChange(newValue)
  }

  useEffect(() => {
    if (valor) {
      setValue(dayjs(valor))
    }
  }, [valor])

  if (views && !views.includes('day') && !views.includes('month') && !views.includes('year')) {
    return (
      <MobileTimePicker
        placeholder={`${campo.etiqueta}${campo.obligatorio === 'S' ? ' *' : ''}`}
        views={views}
        openTo={openTo}
        value={value}
        disabled={campo.desactivado === 'S'}
        onChange={handleChange}
        slotProps={{
          clearable: true,
          textField: {
            helperText: campo.ayuda,
            error: campo.error,
          },
        }}
        minDate={dates?.minDate ?? null}
        maxDate={dates?.maxDate ?? null}
        sx={{ width: '100%' }}
      />
    )
  }
  if (
    views &&
    !views.includes('hours') &&
    !views.includes('minutes') &&
    !views.includes('seconds')
  ) {
    return (
      <DatePicker
        placeholder={`${campo.etiqueta}${campo.obligatorio === 'S' ? ' *' : ''}`}
        views={
          views.includes('day') && views.includes('month') && views.includes('year') ? null : views
        }
        value={value}
        disabled={campo.desactivado === 'S'}
        onChange={handleChange}
        slotProps={{
          clearable: true,
          textField: {
            helperText: campo.ayuda,
            error: campo.error,
          },
        }}
        minDate={dates?.minDate ?? null}
        maxDate={dates?.maxDate ?? null}
        sx={{ width: '100%' }}
      />
    )
  }
  return (
    <MobileDateTimePicker
      placeholder={`${campo.etiqueta}${campo.obligatorio === 'S' ? ' *' : ''}`}
      views={views}
      openTo={openTo}
      value={value}
      disabled={campo.desactivado === 'S'}
      onChange={handleChange}
      slotProps={{
        clearable: true,
        textField: {
          helperText: campo.ayuda,
          error: campo.error,
        },
      }}
      minDate={dates?.minDate ?? null}
      maxDate={dates?.maxDate ?? null}
      sx={{ width: '100%' }}
    />
  )
}

export default CustomDateTimeComponent
